import React from 'react';
import { colors } from 'ui_system/compass';
import IconProps from '../iconTypes';

export const EyeIcon: React.FC<IconProps> = ({
  width = '20',
  height = '20',
  color = 'currentColor',
  ...attributes
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 31.94368 19.7408"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...attributes}
    >
      <g stroke={color} strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(0, -6)">
          <path
            d="M16.01072,6.001 L16.05216,6.00224 C16.08064,6.00192 16.10848,6 16.13696,6 C16.3376,6 16.53696,6.008 16.73472,6.01984 C27.16992,6.43104 31.5728,15.12608 31.75904,15.50496 L31.94368,15.88064 L31.7536,16.25344 C31.56096,16.63136 27.01632,25.30208 16.73952,25.72064 C16.54016,25.7328 16.33952,25.7408 16.13696,25.7408 C16.10848,25.7408 16.08032,25.73888 16.05184,25.73856 L15.96928,25.7408 C5.19621189,25.7408 0.614256012,17.1113523 0.201729117,16.2876599 L0.17696,16.23744 L4.26325641e-14,15.87072 L0.1792,15.50528 C0.36992,15.11712 4.97632,6 15.96928,6 C15.99744,6 16.024,6.00192 16.05216,6.00224 Z M16.05728,7.67328 C11.57408,7.71616 7.9392,11.376 7.9392,15.8704 C7.9392,20.36448 11.57344,24.024 16.05664,24.06752 C16.24512,24.06656 16.43136,24.06144 16.616,24.0544 C20.9136,23.80544 24.3344,20.2304 24.3344,15.8704 C24.3344,11.5088 20.91136,7.93312 16.61152,7.68608 C16.42848,7.67936 16.24416,7.67424 16.05728,7.67328 Z M8.72736,9.36128 C4.67264,11.41888 2.51264,14.75808 1.87648,15.87648 C2.50784,17.00032 4.65984,20.36064 8.75552,22.41216 C7.2096,20.66912 6.26816,18.37792 6.26816,15.8704 C6.26816,13.37792 7.1984,11.10016 8.72736,9.36128 Z M23.82368,9.69024 C25.1872,11.38336 26.00544,13.53248 26.00544,15.8704 C26.00544,18.17728 25.208,20.30016 23.87712,21.9824 C27.45152,19.91968 29.43648,16.92384 30.05696,15.86752 C29.44768,14.79968 27.47328,11.75296 23.82368,9.69024 Z M16.136704,11.317184 C18.520384,11.317184 20.452864,13.249344 20.452864,15.633024 C20.452864,18.016704 18.520384,19.948864 16.136704,19.948864 C13.753344,19.948864 11.820864,18.016704 11.820864,15.633024 C11.820864,13.249344 13.753344,11.317184 16.136704,11.317184 Z"
            fill={colors.text.icon}
          />
        </g>
      </g>
    </svg>
  );
};
